import { Dialog, DialogTitle, Divider, Grid, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer,
   TableHead, TablePagination, TableRow,ToggleButton, Typography, } from "@mui/material";
import React, { useState } from "react";
import { useEffect } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import BillingService from "../../../Services/MasterBilling/BillingService";
import Home from "../../home/Home";
import Snacbar from "../../Snacbar";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useNavigate } from "react-router";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: 'rgb(61, 195, 177)',
    color: theme.palette.common.black,
      textAlign: "center",
      padding: theme.spacing(0.5),
      fontFamily: 'Times New Roman',
      fontWeight: 'bold'
  },
  [`&.${tableCellClasses.body}`]: {
    textAlign: "center",
    fontSize: 14,
    fontFamily: 'Times New Roman',
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
}));
const ItemPap = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  // border: " 1px solid black",
  // backgroundColor: "#C8EDE7",
  height: "100%",
}));
const ItemPap1 = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  backgroundColor: "white",
  height: "100%",
}));

function Chargetype() {
  const mystyle = {
    border: " 1px solid black",
    width: "10rem",
    fontFamily: 'Times New Roman',
  };
  const mystyle1 = {
    fontWeight: "bolder",
    color: "red",
    fontFamily: 'Times New Roman',
  };
  const [charge, setcharge] = useState({
    chargetype: '',
    oldChargeType: ''
  });

  const [saveDsa, setSaveDsa] = useState(false);
  const [updateDsa, setUpdateDsa] = useState(true);
  const [deleteDsa, setDeleteDsa] = useState(true);

  const [Deletes, setDelete] = useState(false);
  const [save, setSave] = useState(false);
  const [update, setUpdate] = useState(false);

  const [open, setOpen] = useState(false);
  const [severity, setSeverity] = useState('');
  const [message, setMessage] = useState('');

  const [error, setError] = useState(false)

  const [details, setDetails] = useState([]);
  const [Filterddetails, setFilterddetails] = useState([]);

  const chargetypehandlechange = (e) => {
    setcharge({ ...charge, chargetype: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') });
  };

  //getData

  const getChargeType = async () => {
    BillingService.getChargeType().then((res) => {
      setDetails(res.data);
      setFilterddetails(res.data);
    })
  }

  useEffect(() => {
    // const getChargeType = async () => {
    //   BillingService.getChargeType().then((res) => {
    //     setDetails(res.data);
    //     setFilterddetails(res.data);
    //   })
    // }
    getChargeType();
  }, []);

  //tableClick
  const editChargeDetails = (item) => {
    setSaveDsa(true);
    setUpdateDsa(false);
    setDeleteDsa(false);
    setSave(false);
    setUpdate(false);
    setDelete(false);
    setcharge({ ...charge, chargetype: item.chargeTypeName, oldChargeType: item.chargeTypeName });
  }

  //handleClose/open
  const handleClose = () => {
    setOpen(false);
  }
  //icon
  const deleteicon = () => {
    return <DeleteOutlineRoundedIcon style={{ color: 'red' }} />
  }
  //clickEvents

  const validate = () => {
    if (charge.chargetype !== '') {
      return true;
    } else {
      setError(true);
      document.getElementById('chargeType').focus();
      setOpen(true); setSeverity('warning'); setMessage('Please Enter Charge Type Name ..!!')
    }
    return false;
  }

  const SaveDetails = () => {
    if (validate() === true) {
      setSaveDsa(true); setSave(true);
      let details = { chargeTypeName: charge.chargetype }
      BillingService.insertChargeType(details).then((res) => {
        const message = res.data.message;
        if (message.toString(details) === 'SUCCESS') {
          setOpen(true); setSeverity('success'); setMessage(message);
        } else {
          setOpen(true); setSeverity('error'); setMessage('Insertion Failed');
        } refresh();
      }).catch(error => {
        setOpen(true); setSeverity('error'); setMessage(error.message); refresh();
      })
    }
  }
  const updateDetails = () => {
    if (validate() === true) {
      setUpdateDsa(true); setUpdate(true);
      let details = { oldChargeTypeName: charge.oldChargeType, chargeTypeName: charge.chargetype }
      BillingService.updateChargeType(details).then((res) => {
        const message = res.data.message;
        if (message.toString(details) === 'SUCCESS') {
          setOpen(true); setSeverity('success'); setMessage(message);
        } else {
          setOpen(true); setSeverity('error'); setMessage('Updation Failed');
        } refresh();
      }).catch(error => {
        setOpen(true); setSeverity('error'); setMessage(error.message); refresh();
      })
    }
  }
  const DeleteDetails = () => {
    setDeleteDsa(true); setDelete(true);
    setalertopen(true)
  }

  const refresh = () => {
    setPage(0)
    setSaveDsa(false);
    setUpdateDsa(true);
    setDeleteDsa(true);
    setSave(false);
    setUpdate(false);
    setDelete(false);
    setcharge({ ...charge, chargetype: '', oldChargeType: '' });
    setError(false);
    getChargeType();
  }
  const Chrg_typNm_Srch = () => {
    return <input className="searchBoxes" onChange={(e) => { ChargenameSearch(e.target.value) }} placeholder={"Search"} />
  }
  const ChargenameSearch = (searchedVal) => {
    const filtervalue = details.filter((trns) => {
      return trns.chargeTypeName.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (searchedVal.length < 1) {
      setFilterddetails(details)
    } else {
      setFilterddetails(filtervalue)
    }
  }
  //paginationCodes

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  }
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  }
  //alertbox
  const [alertopen, setalertopen] = useState(false);

  const alertonClickOpen = (item) => {
    setcharge({ ...charge, oldChargeType: item.chargeTypeName })
    setalertopen(true)
  }

  const alertNoOnClick = () => {
    refresh();
    setalertopen(false)
  }

  const alertYesOnClick = () => {
    BillingService.deleteChargeType(charge.oldChargeType).then((res) => {
      const message = res.data.message;
      if (message.toString(details) === 'SUCCESS') {
        setOpen(true); setSeverity('success'); setMessage(message);
      } else {
        setOpen(true); setSeverity('error'); setMessage('Failed To Delete');
      } refresh();
    }).catch(error => {
      setOpen(true); setSeverity('error'); setMessage(error.message); refresh();
    })
    setalertopen(false)
  }

  const navigate = useNavigate();
  const BackBotton =()=>{
    navigate('/ClearanceLoc');
  }
  const ForwordBotton =()=>{
    navigate('/Itemtype');
  }
  return (
    <div>
      <Dialog open={alertopen}>
        <DialogTitle>
          <center><h6 style={{ fontFamily: 'Times New Roman'}}>ARE YOU SURE,</h6></center>
          <h6 style={{ fontFamily: 'Times New Roman'}}>YOU WANT TO DELETE ?</h6>
          <Divider color="#FDA228" sx={{ height: 2 }} />
        </DialogTitle>
        <div className="form-inline p-1">
          <center><Button  variant="danger" className="p-1 mb-2 mr-1" style={{ width: '50px',fontFamily: 'Times New Roman' }} onClick={alertYesOnClick}>Yes</Button>&nbsp;
            <Button variant="success" className="p-1 mb-2 " style={{ width: '50px' }} onClick={alertNoOnClick}>No</Button></center>
        </div>
      </Dialog>
      <Home /><Snacbar open={open} message={message} severity={severity} onClose={handleClose} />
      <div style={{ paddingLeft: "80px" }}>
      <Row>
                    <Col xs={1}><ToggleButton onClick={BackBotton} className='headerstyleStrt' size="small">
                        <ArrowBackIosIcon fontSize="small" style={{ fontSize: '16px', marginLeft: '5px', color: 'red', fontWeight: 'bold' }} /> </ToggleButton></Col>
                    <Col xs={10}></Col>
                    <Col xs={1} style={{textAlign:'end'}}> <ToggleButton onClick={ForwordBotton} className='headerstyleEND' size="small">
                        <ArrowForwardIosIcon fontSize="small" style={{ fontSize: '16px', color: 'red', fontWeight: 'bold' }} /> </ToggleButton>
                    </Col>
                </Row>
        <ItemPap>
          <Grid container>
            <Grid xs={4} style={{ marginTop: "1rem" }}>
            <Row>
                <Col xs={1}>
          {/* <ToggleButton onClick={BackBotton} className='headerstyleStrt' size="small"> <ArrowBackIosIcon fontSize="small" style={{ fontSize: '16px',marginLeft:'5px' }} /> </ToggleButton> */}
            </Col>
            <Col xs={11}>
              <Typography style={{ fontFamily: 'Times New Roman'}} color={"#0b64c5"} fontWeight={"bolder"} variant={"h5"}>
                ChargeType Details Entry
              </Typography><hr></hr>
              </Col>
              </Row>
              <Row className="mt-3">
                <Col xs={5}>
                  <label style={mystyle1}>ChargeTypeName*</label>
                </Col>
                <Col xs={7}>
                  <Form.Control size="sm" type="text" style={mystyle} required isInvalid={error}
                    value={charge.chargetype} onChange={chargetypehandlechange} id='chargeType' />
                </Col>
              </Row>
              <Row className="mt-2">
                <Col lg={1}></Col>
                <Col lg={10}>
                  <Button style={{ fontFamily: 'Times New Roman'}}variant="success" size="sm" disabled={saveDsa} onClick={SaveDetails}>
                    {save ? 'processing..' : 'Save'}
                  </Button>
                  &nbsp;
                  <Button style={{ fontFamily: 'Times New Roman'}}variant="primary" size="sm" disabled={updateDsa} onClick={updateDetails}>
                    {update ? 'Processing..' : 'Update'}
                  </Button>
                  &nbsp;
                  <Button style={{ fontFamily: 'Times New Roman'}}variant="danger" size="sm" disabled={deleteDsa} onClick={DeleteDetails}>
                    {Deletes ? 'Processing..' : 'Delete'}
                  </Button>
                  &nbsp;
                  <Button style={{ fontFamily: 'Times New Roman'}}variant="secondary" size="sm" onClick={refresh}>
                    Refresh
                  </Button>
                </Col>
                <Col lg={1}></Col>
              </Row>
            </Grid>

            <Grid xs={8} style={{ marginTop: "1rem" }}>
              <ItemPap1>
                <Row>
                  <Col xs={11}>
                <Typography color={"#0b64c5"} fontWeight={"bolder"} variant={"h5"}style={{ fontFamily: 'Times New Roman'}}>
                  Existing  ChargeType Details
                </Typography>
                </Col>
                <Col xs={1}>
                 {/* <ToggleButton onClick={ForwordBotton} className='headerstyleEND' size="small"> 
                <ArrowForwardIosIcon fontSize="small" style={{ fontSize: '16px'}} /></ToggleButton>  */}
                  </Col>
                </Row>
                <TableContainer sx={{ height: 440 }} style={{ marginTop: "1px" }}>
                  <Table stickyHeader className="table table-bordered">
                    <TableHead>
                      <StyledTableRow>
                        <StyledTableCell style={{ width: "1rem" }}>SlNo</StyledTableCell>
                        <StyledTableCell>ChargeType Name {Chrg_typNm_Srch()}</StyledTableCell>
                        <StyledTableCell style={{ textAlign: 'center' }}>Actions</StyledTableCell>
                      </StyledTableRow>
                    </TableHead>
                    <TableBody>
                      {Filterddetails.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        .map((item, index) => (
                          <StyledTableRow hover key={item.chargeTypeName} onClick={() => editChargeDetails(item)}>
                            <StyledTableCell style={{ width: "1rem",textAlign: 'center' }}>{item.serialNumber}</StyledTableCell>
                            <StyledTableCell style={{textAlign: 'center'}}>{item.chargeTypeName}</StyledTableCell>
                            <StyledTableCell style={{textAlign: 'center'}}><lu onClick={() => alertonClickOpen(item)}>{deleteicon()}</lu></StyledTableCell>
                          </StyledTableRow>))}
                    </TableBody>
                  </Table>
                </TableContainer>
                <TablePagination
                  showFirstButton
                  showLastButton
                  component='div'
                  count={Filterddetails.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onChangeRowsPerpage={handleChangeRowsPerPage}
                />
              </ItemPap1>
            </Grid>
          </Grid>
        </ItemPap>
      </div>
    </div>
  );
}

export default Chargetype;
